import Home from 'src/features/routes/home/Home';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';
import MainLayout from 'src/components/layout/MainLayout';
import HomeRedirect from 'src/features/routes/home/HomeRedirect';

const HomeRoutes = () => {
    const accessHomeStats = useHasPermissions([PERMISSION.ACCESS_HOME_STATS]);

    return <MainLayout>{accessHomeStats ? <Home /> : <HomeRedirect />}</MainLayout>;
};

export default HomeRoutes;
